import { userTypes } from 'options/userTypes';

export const isAnyBuyer = (userType) => {
  return userType === userTypes.buyer || userType === userTypes.buyerAdmin || userType === userTypes.buyerUser;
};
